import Vue from 'vue'
import { VVtFocus } from '@/directives/focus.directive'
import { VVtTesting } from '@/directives/testing.directive'
import { VVtTooltip } from '@/directives/tooltip.directive'
import { VVtTooltipAutoShow } from '@/directives/tooltip-auto-show.directive'

Vue.directive('focus', VVtFocus)
Vue.directive('testing', VVtTesting)
Vue.directive('tooltip', VVtTooltip)
Vue.directive('tooltipAutoShow', VVtTooltipAutoShow)
